// Anchor points of building art that the board renderer overlays (M10): drawing geometry in cell units
// (0–1 from the frame's top-left, the 100-unit art grid ÷ 100), shared by the generators that draw the
// feature and by render/juice/geometry.ts that places FX and contents indicators on it — one home, so an
// art change moves its overlay with it.

/** The Gallery booth (machines/structures.ts galleryParts). */
export const GALLERY = {
  /** Target pegs on the rail (x) and the rail's top edge (y): standing targets rest their base on it. */
  pegX: [0.26, 0.5, 0.74] as const,
  railY: 0.46,
  /** The gun stand on the counter (the mounted gun's centre sits above it). */
  stand: { x: 0.5, y: 0.56 },
  /** Ammo-queue dots on the front strip: count, first centre, spacing, radius. */
  queueDots: 4,
  queueDot: { x: 0.16, dx: 0.09, y: 0.84, r: 0.032 },
  /** Free counter space left of the gun stand (the queued-ammo icon) and its count right of the stand. */
  counterIcon: { x: 0.25, y: 0.66 },
  counterCount: { x: 0.77, y: 0.66 },
} as const;

/** The Loader's three funnels (machines/processors.ts loaderParts): centres and the material fill line. */
export const LOADER = {
  funnelX: [0.22, 0.5, 0.78] as const,
  fillY: 0.15,
} as const;

/** The Crate's cream label on the top face (machines/structures.ts crateParts). */
export const CRATE = {
  label: { x: 0.5, y: 0.39 },
  count: { x: 0.5, y: 0.6 },
} as const;

/** The Smelter (machines/processors.ts smelterParts): the heat gauge beside the dome. */
export const SMELTER = {
  gauge: { x: 0.1, y: 0.47 },
} as const;

/** The Caster's crucible (machines/processors.ts casterParts): the pour glow sits on its molten surface. */
export const CASTER = {
  pour: { x: 0.34, y: 0.35 },
} as const;

/** The gun frame (parts/gun): the ejection port a spent casing tinkles out of, in cell units of the frame. */
export const GUN = {
  port: { x: 0.42, y: 0.44 },
} as const;
